export default "__VITE_ASSET__da854bca__"